import { jwtDecode } from "jwt-decode"; // ✅ named import

/**
 * Checks if the token has expired. If expired, logs the user out.
 * Automatically sets a timeout to log out when the token expires.
 */
export const checkTokenExpiration = () => {
  const token = localStorage.getItem("authToken");

  if (!token) return;

  try {
    const decoded = jwtDecode(token);
    const now = Date.now();
    const expTime = decoded.exp * 1000; // convert to milliseconds
    const timeLeft = expTime - now;

    if (timeLeft <= 0) {
      // Token already expired
      localStorage.clear();
      window.location.href = "/";
    } else {
      // Set a timeout to auto logout when token expires
      setTimeout(() => {
        localStorage.clear();
        window.location.href = "/";
      }, timeLeft);
    }
  } catch (error) {
    console.error("Error decoding token:", error);
    localStorage.clear();
    window.location.href = "/";
  }
};
